/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Sakshi's Portfolio",
  description:
    "Passionate Software Developer. Designing robust and scalable systems for seamless performance. Passionate about developing innovative solutions for complex problems.",
  og: {
    title: "Sakshi Dubey Portfolio",
    type: "website",
    // url: "http://ashutoshhathidara.com/",
  },
};

//Home Page
const greeting = {
  title: "Sakshi Dubey",
  logo_name: "SakshiDubey",
  // nickname: "layman_brother",
  subTitle:
    "Senior Software Engineer | Designing robust and scalable systems for seamless performance | Passionate about developing innovative solutions for complex problems",
  resumeLink:
    "https://drive.google.com/file/d/1fArQZ8YKkUzK0N_0cBNQxPBGL5Q4HbMW/view?usp=share_link",
  // portfolio_repository: "https://github.com/ashutosh1919/masterPortfolio",
  githubProfile: "https://github.com/sakshidubey2",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/sakshidubey2",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "http://www.linkedin.com/in/sakshi-dubey",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://youtube.com/c/DevSense19",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:sakshi2014dubey@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/Sakshi_Dubey210",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/laymanbrother.19/",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  // {
  //   name: "Instagram",
  //   link: "https://www.instagram.com/layman_brother/",
  //   fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
  //   backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  // },
];

const skills = {
  data: [
    // {
    //   title: "Data Science & AI",
    //   fileName: "DataScienceImg",
    //   skills: [
    //     "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
    //     "⚡ Experience of working with Computer Vision and NLP projects",
    //     "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Tensorflow",
    //       fontAwesomeClassname: "logos-tensorflow",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Keras",
    //       fontAwesomeClassname: "simple-icons:keras",
    //       style: {
    //         backgroundColor: "white",
    //         color: "#D00000",
    //       },
    //     },
    //     {
    //       skillName: "PyTorch",
    //       fontAwesomeClassname: "logos-pytorch",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Python",
    //       fontAwesomeClassname: "ion-logo-python",
    //       style: {
    //         backgroundColor: "transparent",
    //         color: "#3776AB",
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: "Full Stack Development",
    //   fileName: "FullStackImg",
    //   skills: [
    //     "⚡ Building responsive website front end using React-Redux",
    //     "⚡ Developing mobile applications using Flutter, React Native and solo android apps using Kotlin",
    //     "⚡ Creating application backend in Node, Express & Flask",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "HTML5",
    //       fontAwesomeClassname: "simple-icons:html5",
    //       style: {
    //         color: "#E34F26",
    //       },
    //     },
    //     {
    //       skillName: "CSS3",
    //       fontAwesomeClassname: "fa-css3",
    //       style: {
    //         color: "#1572B6",
    //       },
    //     },
    //     {
    //       skillName: "Sass",
    //       fontAwesomeClassname: "simple-icons:sass",
    //       style: {
    //         color: "#CC6699",
    //       },
    //     },
    //     {
    //       skillName: "JavaScript",
    //       fontAwesomeClassname: "simple-icons:javascript",
    //       style: {
    //         backgroundColor: "#000000",
    //         color: "#F7DF1E",
    //       },
    //     },
    //     {
    //       skillName: "ReactJS",
    //       fontAwesomeClassname: "simple-icons:react",
    //       style: {
    //         color: "#61DAFB",
    //       },
    //     },
    //     {
    //       skillName: "NodeJS",
    //       fontAwesomeClassname: "simple-icons:node-dot-js",
    //       style: {
    //         color: "#339933",
    //       },
    //     },
    //     {
    //       skillName: "NPM",
    //       fontAwesomeClassname: "simple-icons:npm",
    //       style: {
    //         color: "#CB3837",
    //       },
    //     },
    //     {
    //       skillName: "Yarn",
    //       fontAwesomeClassname: "simple-icons:yarn",
    //       style: {
    //         color: "#2C8EBB",
    //       },
    //     },
    //     {
    //       skillName: "Gatsby",
    //       fontAwesomeClassname: "simple-icons:gatsby",
    //       style: {
    //         color: "#663399",
    //       },
    //     },
    //     {
    //       skillName: "Flutter",
    //       fontAwesomeClassname: "simple-icons:flutter",
    //       style: {
    //         color: "#02569B",
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: "Cloud Infra-Architecture",
    //   fileName: "CloudInfraImg",
    //   skills: [
    //     "⚡ Experience working on multiple cloud platforms",
    //     "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
    //     "⚡ Deploying deep learning models on cloud to use on mobile devices",
    //     "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "GCP",
    //       fontAwesomeClassname: "simple-icons:googlecloud",
    //       style: {
    //         color: "#4285F4",
    //       },
    //     },
    //     {
    //       skillName: "AWS",
    //       fontAwesomeClassname: "simple-icons:amazonaws",
    //       style: {
    //         color: "#FF9900",
    //       },
    //     },
    //     {
    //       skillName: "Azure",
    //       fontAwesomeClassname: "simple-icons:microsoftazure",
    //       style: {
    //         color: "#0089D6",
    //       },
    //     },
    //     {
    //       skillName: "Firebase",
    //       fontAwesomeClassname: "simple-icons:firebase",
    //       style: {
    //         color: "#FFCA28",
    //       },
    //     },
    //     {
    //       skillName: "PostgreSQL",
    //       fontAwesomeClassname: "simple-icons:postgresql",
    //       style: {
    //         color: "#336791",
    //       },
    //     },
    //     {
    //       skillName: "MongoDB",
    //       fontAwesomeClassname: "simple-icons:mongodb",
    //       style: {
    //         color: "#47A248",
    //       },
    //     },
    //     {
    //       skillName: "Docker",
    //       fontAwesomeClassname: "simple-icons:docker",
    //       style: {
    //         color: "#1488C6",
    //       },
    //     },
    //     {
    //       skillName: "Kubernetes",
    //       fontAwesomeClassname: "simple-icons:kubernetes",
    //       style: {
    //         color: "#326CE5",
    //       },
    //     },
    //   ],
    // },
    {
      title: "Software Development",
      fileName: "DesignImg",
      imagePath: "what_i_do_main.svg",
      skills: [
        "⚡ As a software developer with 4 years of experience, I have worked extensively in Python, JavaScript, TypeScript, AWS, and Docker services. My focus has primarily been on the backend side, where I have designed and developed applications that meet the needs of various businesses. In addition to developing code, I have also led teams of junior developers and interns, helping them learn new skills and gain valuable experience.",
        "⚡ I am passionate about software design and architecture and have taken part in design discussions to ensure that the applications I build are efficient, scalable, and maintainable. I take a customer-focused approach to software development and work closely with stakeholders to understand their needs and create solutions that meet their requirements.",
        "⚡ On my website, you will find information about my experience and skills, as well as examples of my work. I am always looking for new challenges and opportunities to learn, and I am excited to work with clients who share my passion for creating high-quality software solutions.",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Javascript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "simple-icons:inkscape",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
        {
          skillName: "Typescript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            color: "#326CE5",
          },
        },
        {
          skillName: "Github",
          fontAwesomeClassname: "fa-github",
          style: {
            color: "#181717",
          },
        },
        {
          skillName: "Golang",
          fontAwesomeClassname: "skill-icons:golang",
          style: {
            color: "#181717",
          },
        },
        {
          skillName: "Rest API",
          fontAwesomeClassname: "dashicons:rest-api",
          style: {
            color: "#181717",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "logos:postgresql",
          style: {
            color: "#181717",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "skill-icons:mongodb",
          style: {
            color: "#181717",
          },
        },
        {
          skillName: "Loopback",
          fontAwesomeClassname: "logos:loopback",
          style: {
            color: "#181717",
          },
        },
        {
          skillName: "NestJs",
          fontAwesomeClassname: "vscode-icons:file-type-nest-controller-js",
          style: {
            color: "#181717",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/sakshidubey/",
    },
    // {
    //   siteName: "HackerRank",
    //   iconifyClassname: "simple-icons:hackerrank",
    //   style: {
    //     color: "#2EC866",
    //   },
    //   profileLink: "https://www.hackerrank.com/layman_brother",
    // },
    // {
    //   siteName: "Codechef",
    //   iconifyClassname: "simple-icons:codechef",
    //   style: {
    //     color: "#5B4638",
    //   },
    //   profileLink: "https://www.codechef.com/users/ashutosh_1919",
    // },
    // {
    //   siteName: "Codeforces",
    //   iconifyClassname: "simple-icons:codeforces",
    //   style: {
    //     color: "#1F8ACB",
    //   },
    //   profileLink: "http://codeforces.com/profile/layman_brother",
    // },
    // {
    //   siteName: "Hackerearth",
    //   iconifyClassname: "simple-icons:hackerearth",
    //   style: {
    //     color: "#323754",
    //   },
    //   profileLink: "https://www.hackerearth.com/@ashutosh391",
    // },
    // {
    //   siteName: "Kaggle",
    //   iconifyClassname: "simple-icons:kaggle",
    //   style: {
    //     color: "#20BEFF",
    //   },
    //   profileLink: "https://www.kaggle.com/laymanbrother",
    // },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Indian Institute of Information Technology (IIIT) Vadodara",
      subtitle: "B.Tech. in Computer Science Engineering",
      logo_path: "iiitv_logo.png",
      alt_name: "IIIT Vadodara",
      duration: "2015 - 2019",
      descriptions: [
        "⚡ I have completed my graduation in Computer Science Engineering.",
        "⚡ During my college I have done courses in DSA, Algorithms, DBMS, OS, AI etc.",
      ],
      website_link: "https://iiitvadodara.ac.in/",
    },
    // {
    //   title: "Indiana University Bloomington",
    //   subtitle: "M.S. in Computer Science",
    //   logo_path: "iu_logo.png",
    //   alt_name: "Indiana University Bloomington",
    //   duration: "2021 - 2023",
    //   descriptions: [
    //     "⚡ I have taken varity of courses related to Artificial Intelligence which correspond to Explainable AI, Graph Machine Learning, Computer Vision etc.",
    //     "⚡ Apart from this, I have also done research assistantship. As part of it, I have worked on creating new algorithms in Graph ML and Network Science.",
    //     "⚡ During my time at university, I was also associated with multimedia department. As part of it, I have worked on some documentry films and interviews.",
    //   ],
    //   website_link: "https://www.indiana.edu/",
    // },
  ],
};

const projectsnew = {
  degrees: [
    {
      title: "Building a CI/CD Pipeline for Golang Microservices using Github Actions and Grpc Mocking",
      subtitle: "Conversenow.Ai",
      logo_path: "conversenow_logo.png",
      alt_name: "conversenow",
      // duration: "2015 - 2019",
      descriptions: [
        "The project which I am working on currently is, to build and maintain the Continuous Integration (CI) pipeline using Github Actions. The purpose of this pipeline is to ensure that all services and microservices written in Golang are running as expected by running integration and unit tests.",
        "To achieve this, I have implemented a test suite using GRPC record calls. These calls help in recording interactions with the microservices and the database, enabling us to mock the connections to the services for testing purposes instead of using actual services on the server. In addition, I use tools such as grpc-replay, copyist, and redismock for recording the calls.",
        "The CI pipeline runs every time a code change is pushed to the repository, and it connects to all the recorded services to ensure that everything is running correctly. The pipeline also measures the percentage of functions covered while running the tests to ensure that we have a high level of test coverage and identify areas that may require additional testing.",
        "Through this process, we can detect any issues in the codebase and ensure that all services and microservices are functioning as intended before they are deployed to production. By using a robust testing framework, we can reduce the likelihood of errors or issues that can impact the end-users.",
        "⚡ Tools and Languages Used -  Golang, Github Actions, grpc replay, copyist, redismock"
      ],
      // website_link: "https://iiitvadodara.ac.in/",
    },
    {
      title: "Webhook Service Project",
      subtitle: "Shipsy",
      logo_path: "shipsy_logo.png",
      alt_name: "shipsy",
      // duration: "2015 - 2019",
      descriptions: [
        "I built a Webhook Service to handle a large number of user requests related to tracking updates of consignments. The system was designed to receive webhook requests from a third-party service, validate the incoming data, and process it accordingly. To handle the high traffic and ensure reliability, I used AWS Simple Queue Service (SQS) to receive the requests and push them to the API, which would then check the request and update the status of the consignment in the database.",
        "To develop this project, I utilized my expertise in Python and JavaScript. Python was used for the backend and processing of the incoming webhook requests, while JavaScript was used for the frontend and client-side interactions. I also incorporated New Relic and Elasticsearch to monitor and analyze the performance of the system.",
        "Overall, the Webhook Service project was a challenging and rewarding experience, where I gained a deeper understanding of how to build a scalable, reliable, and efficient system to handle a large volume of user requests.",
        "⚡ Tools and Languages Used - Python, Javascript, NodeJs, PostgreSql, AWS SQS, NewRelic, ElasticsSearch"
      ],
      // website_link: "https://iiitvadodara.ac.in/",
    },
    {
      title: "RDS-ETL Pipeline Project",
      subtitle: "Shipsy",
      logo_path: "shipsy_logo.png",
      alt_name: "shipsy",
      // duration: "2021 - 2023",
      descriptions: [
        "In the RDS ETL pipeline project, I was responsible for building a data pipeline that would fetch data from Shipsy's database and transfer it to another system based on the client's requirements. The project was built using Python and involved working with large amounts of data.",
        "The pipeline was designed in a way that whenever a new functionality of adding a new pipeline of data transfer came up, we would need to make changes to the configuration if that pipeline already existed. The data transfer was based on client requests and involved transferring data to various systems such as S3, Azure, Postgres, etc.",
        "To handle the large amount of data, we used cron job functionality to schedule the data transfers. This ensured that the data transfers were done at the client's preferred time and in a way that did not cause any disruption to their business operations. Overall, the RDS ETL pipeline project was a challenging and rewarding project that allowed me to hone my skills in Python, data handling, and project management.",
        "⚡ Tools and Languages Used - Python, PostgreSql, AWS S3, Azure"
      ],
      // website_link: "https://www.indiana.edu/",
    },
    {
      title: "Third Party Logistics (3PL) Integrations Project",
      subtitle: "Shipsy",
      logo_path: "shipsy_logo.png",
      alt_name: "shipsy",
      // duration: "2021 - 2023",
      descriptions: [
        "In my role at Shipsy, I worked on a 3PL integrations project where I was responsible for the booking, tracking, cancelling, and label integrations for various third-party courier partners such as Delhivery, BlueDart, DHL, and others. This integration was a major part of the logistics process, where allocation rules were set in the booking management dashboard. These allocation rules were based on city, pincode, area, and other factors. Whenever a consignment was uploaded, it was automatically booked with the appropriate 3PL courier based on the allocation rules set in the system.",
        "Since these were third-party vendors, API documentation needed to be thoroughly understood to ensure proper error handling and other factors were considered. Similarly, error handling needed to be implemented at Shipsy's end as well to provide a comprehensive response to the customer whenever a booking was successful or unsuccessful.",
        "Overall, the 3PL integrations project required a deep understanding of the logistics industry and the APIs of various courier partners. It also required strong problem-solving skills to develop and implement the allocation rules to ensure efficient and cost-effective courier allocation.",
        "⚡ Tools and Languages Used - NodeJs, Javascript, Typescript, MongoDb, API's, Docker, Elasticsearch, Newrelic."
      ],
      // website_link: "https://www.indiana.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/WTE64X654TFJ",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Data Analyst Nanodegree",
      subtitle: "- Udacity",
      logo_path: "udacity_logo.svg",
      certificate_link:
        "https://learn.udacity.com/view-certificate/nd002",
      alt_name: "Data Analyst",
      color_code: "#00000099",
    },
    {
      title: "Intro to Programming Nanodegree",
      subtitle: "- Udacity",
      logo_path: "udacity_logo.svg",
      certificate_link:
        "https://learn.udacity.com/view-certificate/nd000",
      alt_name: "Udacity",
      color_code: "#0C9D5899",
    },
    {
      title: "Predictive Analytics for Business Nanodegree",
      subtitle: "- Udacity",
      logo_path: "udacity_logo.svg",
      certificate_link:
        "https://learn.udacity.com/view-certificate/nd008t",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Business Analyst Nanodegree",
      subtitle: "- Udacity",
      logo_path: "udacity_logo.svg",
      certificate_link:
        "https://learn.udacity.com/view-certificate/nd008",
      alt_name: "Udacity",
      color_code: "#D83B0199",
    },
    // {
    //   title: "Advanced Data Science",
    //   subtitle: "- Romeo Kienzler",
    //   logo_path: "ibm_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
    //   alt_name: "Udacity",
    //   color_code: "#1F70C199",
    // },
    {
      title: "Machine Learning Basic Nanodegree",
      subtitle: "- Udacity",
      logo_path: "udacity_logo.svg",
      certificate_link:
        "https://learn.udacity.com/view-certificate/nd009-InMB1",
      alt_name: "Udacity",
      color_code: "#0C9D5899",
    },
    // {
    //   title: "DL on Tensorflow",
    //   subtitle: "- Laurence Moroney",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#00000099",
    // },
    // {
    //   title: "Fullstack Development",
    //   subtitle: "- Jogesh Muppala",
    //   logo_path: "coursera_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
    //   alt_name: "Coursera",
    //   color_code: "#2A73CC",
    // },
    // {
    //   title: "Kuberenetes on GCP",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
    // {
    //   title: "Cryptography",
    //   subtitle: "- Saurabh Mukhopadhyay",
    //   logo_path: "nptel_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
    //   alt_name: "NPTEL",
    //   color_code: "#FFBB0099",
    // },
    // {
    //   title: "Cloud Architecture",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Internship",
  description:
    "I have worked with evolving startups as Software Developer. I have worked on multiple backend tech stacks and thrive for learning new technologies. I love building products and working on technologies which solves critical business problems.",
  header_image_path: "experience_new.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Senior Software Engineer",
          company: "Conversenow.Ai",
          company_url: "https://conversenow.ai/",
          logo_path: "conversenow_logo.png",
          duration: "December 2022 - Present",
          location: "Bangalore, Karnataka",
          description:
            "I am working in Platform team, where I am responsible of buidling pipelines for automating integration testing for different services. Working on mocking grpc calls, database and redis for running tests.",
          color: "#9b1578",
        },
        {
          title: "Senior Software Engineer",
          company: "Shipsy",
          company_url: "https://shipsy.io/",
          logo_path: "shipsy_logo.png",
          duration: "October 2019 - October 2022",
          location: "Gurgaon, Haryana",
          description:
          "I worked on various third party integrations which included Booking Integrations with multiple courier partners, SMS integrations and payment integrations. I was responsible of identifying issues in production related to integrations and correcting them.",
          color: "#0879bf",
        },
        // {
        //   title: "Android Developer",
        //   company: "FreeCopy Pvt. Ltd.",
        //   company_url: "https://www.linkedin.com/company/freecopy/about/",
        //   logo_path: "freecopy_logo.png",
        //   duration: "Nov 2017 - Dec 2017",
        //   location: "Ahmedabad, Gujarat",
        //   description:
        //     "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
        //   color: "#fc1f20",
        // },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Data Analyst Intern",
          company: "Enel Green Power",
          company_url: "https://www.enelgreenpower.com/",
          logo_path: "enel_logo.png",
          duration: "January 2019 - June 2019",
          location: "Bangalore, Karnataka",
          description:
            "Developed Real Time Analytics models using Python, ML algorithms and ARIMA models for finding failures in wind turbines from the large collection of historical data. Written the paper which was presented the results to the head office at Italy and the project was approved for analyzing the failure prediction at all sites in India.",
          color: "#000000",
        },
        // {
        //   title: "Data Science Research Intern",
        //   company: "Delhivery Pvt. Ltd.",
        //   company_url: "https://www.delhivery.com/",
        //   logo_path: "delhivery_logo.png",
        //   duration: "May 2019 - Sept 2019",
        //   location: "Gurgaon, Haryana",
        //   description:
        //     "I have worked on project of predicting freight rates based on previous data. There were two objectives: (1) To build a forecasting engine to predict daily freight rates. (2) To embed feature in the model which can explain the seasonal major changes in freight rate based on regions and locations. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2 with the use of Kafka stream jobs, ElasticSearch and PostgreSQL.",
        //   color: "#ee3c26",
        // },
        // {
        //   title: "Data Science Intern",
        //   company: "Intel Indexer LLC",
        //   company_url:
        //     "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
        //   logo_path: "intel_logo.jpg",
        //   duration: "Nov 2018 - Dec 2018",
        //   location: "Work From Home",
        //   description:
        //     "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
        //   color: "#0071C5",
        // },
      ],
    },
    // {
    //   title: "Volunteerships",
    //   experiences: [
    //     {
    //       title: "Google Explore ML Facilitator",
    //       company: "Google",
    //       company_url: "https://about.google/",
    //       logo_path: "google_logo.png",
    //       duration: "June 2019 - April 2020",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
    //       color: "#4285F4",
    //     },
    //     {
    //       title: "Microsoft Student Partner",
    //       company: "Microsoft",
    //       company_url: "https://www.microsoft.com/",
    //       logo_path: "microsoft_logo.png",
    //       duration: "Aug 2019 - May 2020",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
    //       color: "#D83B01",
    //     },
    //     {
    //       title: "Mozilla Campus Captain",
    //       company: "Mozilla",
    //       company_url: "https://www.mozilla.org/",
    //       logo_path: "mozilla_logo.png",
    //       duration: "Oct 2019 - May 2020",
    //       location: "Kurnool, Andhra Pradesh",
    //       description:
    //         "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
    //       color: "#000000",
    //     },
    //     {
    //       title: "Developer Students Club Member",
    //       company: "DSC IIITDM Kurnool",
    //       company_url:
    //         "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
    //       logo_path: "dsc_logo.png",
    //       duration: "Jan 2018 - May 2020",
    //       location: "Kurnool, Andhra Pradesh",
    //       description:
    //         "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
    //       color: "#0C9D58",
    //     },
    //     {
    //       title: "Developer Program Member",
    //       company: "Github",
    //       company_url: "https://github.com/",
    //       logo_path: "github_logo.png",
    //       duration: "July 2019 - PRESENT",
    //       location: "Work From Home",
    //       description:
    //         "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
    //       color: "#181717",
    //     },
    //   ],
    // },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "sakshi_img_new.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with Software Development.",
  },
  // blogSection: {
  //   title: "Blogs",
  //   subtitle:
  //     "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
  //   link: "https://blogs.ashutoshhathidara.com/",
  //   avatar_image_path: "blogs_image.svg",
  // },
  addressSection: {
    title: "Address",
    subtitle:
      "48 Shastri Vihar, Trimurti Nagar, Damoh Naka, Jabalpur, Madhya Pradesh - 482002",
    avatar_image_path: "address_new.svg",
    location_map_link: "https://goo.gl/maps/Wexak23PVVLXquGB6",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
  projectsnew,
};
